
<div class="modal-body selectable">
  <div class="d-flex align-items-start"><img src="/assets/icons/sad-mac.png">
    <div>
      <div *ngIf="reason == 'not-found'">
        <h3 translate>Object not found</h3>
        <label>URL: {{reasonUrl}}</label>
      </div>
      <div *ngIf="reason == 'server-error'">
        <h3 translate>A server error happened</h3>
        <label>URL: {{reasonUrl}}</label>
      </div>
      <div *ngIf="reason == 'connection-error'">
        <h3 translate>Connection failed</h3>
        <label>URL: {{reasonUrl}}</label>
      </div>
      <div *ngIf="reason == 'http-error'">
        <h3 translate>Got HTTP code {{reasonCode}} ({{reasonText}})</h3>
        <label>URL: {{reasonUrl}}</label>
      </div>
      <div *ngIf="reason == 'unknown'">
        <h3 translate>A JS error happened.</h3><span translate>Check the browser console for more info.</span>
      </div>
      <div *ngIf="reason == 'misc'">
        <h3 translate>Route preload error</h3>
        <div>{{reasonText}}</div>
      </div>
    </div>
  </div>
</div>